var map = {
	"./diaDasMaes.png": 2302,
	"./diaDoAmigo.png": 6198,
	"./diaDoHamburguer.jpg": 9172,
	"./diaDoHamburguer.png": 7554,
	"./diaDosNamorados.jpg": 4850,
	"./diaDosPais.png": 9236,
	"./pascoa.png": 7298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1962;